// Register Service Worker for PWA (production only to avoid localhost fetch errors)
export const registerServiceWorker = () => {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  const isLocalhost = typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
  if (isLocalhost) {
    // Evitar error "Failed to update a ServiceWorker": desregistrar cualquier SW previo
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((r) => r.unregister());
    });
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js', { 
        scope: '/',
        updateViaCache: 'none' // Always check for updates
      })
      .then((registration) => {
        // Check for updates immediately
        registration.update();
        
        // Check for updates every hour
        setInterval(() => {
          registration.update();
        }, 60 * 60 * 1000);
        
        // Check for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  // New service worker available
                  // Optionally show a notification to the user
                  if (window.confirm('Nueva versión disponible. ¿Recargar la página?')) {
                    window.location.reload();
                  }
                }
              }
            });
          }
        });
      })
      .catch((error) => {
        console.error('❌ Service Worker registration failed:', error);
        console.error('Error details:', error.message, error.stack);
      });
  });

  // Handle service worker updates
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!refreshing) {
      refreshing = true;
      window.location.reload();
    }
  });
};

// Unregister service worker (useful for development)
export const unregisterServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
};
